module.exports = __webpack_public_path__ + "img/champion.775ba348.png";